import { render, staticRenderFns } from "./KitchenTickets.vue?vue&type=template&id=cd5567d2&scoped=true&"
import script from "./KitchenTickets.vue?vue&type=script&lang=js&"
export * from "./KitchenTickets.vue?vue&type=script&lang=js&"
import style0 from "./KitchenTickets.vue?vue&type=style&index=0&id=cd5567d2&lang=scss&scoped=true&"
import style1 from "./KitchenTickets.vue?vue&type=style&index=1&id=cd5567d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5567d2",
  null
  
)

export default component.exports